import React from 'react';
import { observer } from 'mobx-react';
import { MODE } from '../../mobx/stores/step';
import DebugAuto from './DebugAuto';
import DebugNormal from '../view/DebugNormal';
import Terminal from '../view/Terminal';
import Detect from './Detect';
import { normalDebugStore } from '../../mobx/stores/normal-debug';
import { broadcastStore } from '../../mobx/stores/broadcast';

function Content(props) {
  switch (props.globalStore.operateMode) {
    case MODE.AUTO:
      return <DebugAuto {...props} />;
    case MODE.NORMAL:
      return <DebugNormal
        store={normalDebugStore}
        globalStore={props.globalStore}
        showSwitch={false}
        showNext={false}
      />;
    case MODE.EXPERT:
      return <Terminal showSwitch={false} />;
    case MODE.DETECT:
      return <Detect store={broadcastStore} />;
    default:
      return '';
  }
}

export default observer(Content);
